const PanelContent = {
  baseStyle: {
    ms: "auto",
    me: "auto",
    ps: "0px",
    pe: "0px",
    w: "100%",
    maxWidth: "100%",
  },
};

export const PanelContentComponent = {
  components: {
    PanelContent,
  },
};
